import React from 'react';
import { Link } from 'react-router-dom';
import './CTABanner.css';

const CTABanner = () => {
  return (
    <section className="cta-banner">
      <div className="cta-banner-container">
        <div className="cta-banner-content">
          <h4 className="cta-banner-subtitle">Ready to get started?</h4>
          <h2 className="cta-banner-title">Get Your Free Electrical Quote Today</h2>
          <p className="cta-banner-text">
            Contact us for a free consultation and quote. We're here to help with all your electrical needs.
          </p>
          <Link to="/contact" className="cta-banner-btn">Get My Free Quote</Link>
        </div>
      </div>
    </section>
  );
};

export default CTABanner;
